<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>调班申请</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-card shadow="hover">
            <!-- 搜索 -->
            <el-form :inline="true" size="small" v-model="listQuery">
              <el-form-item label="服务者编号">
                <el-input v-model="listQuery.workerNo" placeholder="请输入服务者姓名" clearable></el-input>
              </el-form-item>
                <el-form-item label="服务者姓名">
                    <el-input v-model="listQuery.workerName" placeholder="请输入服务者姓名" clearable></el-input>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="listQuery.state" clearable placeholder="请选择状态" filterable>
                        <el-option v-for="(item, index) in stateKey" :key="index" :label="item" :value="index + ''">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
                </el-form-item>

            </el-form>

            <!-- 列表数据 -->
            <el-table :data="listData" tooltip-effect="light" border style="width: 100%" class="table">
                <el-table-column type="index" label="序号" width="55"></el-table-column>

                <el-table-column prop="workerNo" label="服务者编号"></el-table-column>
                <el-table-column prop="workerName" label="服务者"></el-table-column>
                <!-- <el-table-column prop="leaveTypeName" label="请假大类"></el-table-column> -->
                <el-table-column prop="teamId" label="班组id"></el-table-column>
                <el-table-column prop="teamName"  label="班组名称"></el-table-column>
                <el-table-column prop="state" label="状态">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.state == 0">未处理</el-tag>
                        <el-tag type="success" v-if="scope.row.state == 1">已更换</el-tag>
                        <el-tag type="danger" v-if="scope.row.state == 2">不可更换</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="comment"  label="原因"></el-table-column>
                <el-table-column prop="createTime" :formatter="dateFormatA" label="创建时间"></el-table-column>

                <el-table-column label="操作" fixed="right" width="200">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.state == 0" v-per="'chuliqingjia'" type="primary" plain size="mini" @click="showchuli(scope.row)">处理
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <pagination :total="total" :page.sync="currentPage" :limit.sync="pageSize" @pagination="querySearch" />
        </el-card>

        <el-dialog title="处理调班" :visible.sync="showcl" width="400px" :close-on-click-modal="false" center>
          <el-form  size="small" v-model="addFrom">
            <el-form-item label="处理状态">
              <el-select v-model="addFrom.state" clearable placeholder="请选择处理状态" filterable>
                <el-option  :key="1" label="已更换" :value="1 + ''"></el-option>
                <el-option  :key="2" label="不可更换" :value="2 + ''"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="原因">
              <el-input
                type="textarea"
                :rows="2"
                placeholder="原因"
                clearable
                filterable
                v-model="addFrom.comment">
              </el-input>
            </el-form-item>
          </el-form>
            <br />
            <span slot="footer" class="dialog-footer">
                <el-button @click="showcl = false">取消</el-button>
                <el-button type="primary" @click="chuli()">确认处理</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
import moment from "moment";
import Pagination from "@/components/common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import crmApi from "@/script/api/workercrmapi";
import globalData from "@/components/common/globaldata/global.data.vue";
let vm;
export default {
    components: { Pagination },
    data() {
        return {
            bookorderState: { 0: '未预约', 1: '已预约', 2: '服务中', 3: '服务已提供', 4: '服务已完成', 5: '取消', 6: '退款' },
            addFile: crmApi.addFile + globalData.userInfo.userAccount,
            stateKey: { 0: "未处理", 1: "已更换", 2: "不可更换"},
            leaveTypeAll: [],
            listData: [],
            bookDataList: [],

            cityList: [],
            postStationList: [],
            allStationList: [],
            allWorkerData: [],
            franchiseeList:[],

            total: 0,
            pageSize: 10,
            currentPage: 1, //当前页
            listQuery: {
                workerName: null,
                state: null,
                leaveTypeId: null,
                cityId: null,
                postStationId: null,
                stationId: null,
                leavePid: null,
                fraId:293
            },
            addLabelImgList: [],
            addFrom: {
                state: '',
                comment:''
            },
            showAdd: false,
            showSP: false,
            showcl: false,
            tempRow: {},
        };
    },

    created() {
        //this.getAllCity();
        //this.getAllPostStation();
        //this.getAllStationList();

        //this.getLeaveDictAll();
        this.querySearch();
        //this.getAllJms();
    },
    methods: {
        getAllJms() {
            crmApi.$ajaxgetAllJms().then(res => {
                this.franchiseeList = res.data.data;
            })
        },
        showchuli(row) {
            this.showcl = true;
            this.tempRow=row;
            this.addFrom={}
        },
        //查询
        querySearch() {
            this.listQuery.pageSize = this.pageSize;
            this.listQuery.pageNum = this.currentPage;
            this.listQuery.userId = globalData.userInfo.id;
            crmApi.$ajaxWorkerApplyTeamList(this.listQuery).then((res) => {
                if (res.data.errno == 0) {
                    this.listData = res.data.data.list;
                    this.total = res.data.data.total;
                }
            });
        },
        getAllWorker() {
            if (this.addFrom.cityId == null || this.addFrom.cityId == "") {
                return; //至少选择城市
            }
            let req = {
                cityId: this.addFrom.cityId,
                postStationId: this.addFrom.postStationId,
                stationId: this.addFrom.stationId,
            };
            crmApi.$ajaxWorkerSupplierGetWorker(req).then((res) => {
                if (res.data.errno == 0) {
                    this.allWorkerData = res.data.data;
                }
            });
        },
        getAllPostStation() {
            //驿站
            crmApi.$axiosPostStationgetAllList({ userId: globalData.userInfo.id }).then((res) => {
                if (res.data.errno == 0) {
                    this.postStationList = res.data.data;
                }
            });
        },
        getAllCity() {
            //城市下拉框
            wmsApi.$axiosgetallCity({ userId: globalData.userInfo.id }).then((res) => {
                if (res.data.errno == 0) {
                    this.cityList = res.data.data;
                }
            });
        },
        getAllStationList() {
            //服务站
            wmsApi.$axiosGetAllStationList({ userId: globalData.userInfo.id }).then((res) => {
                if (res.data.errno == 0) {
                    this.allStationList = res.data.data;
                }
            });
        },
        getcity(id) {
            let nm = null;
            this.cityList.forEach((e) => {
                if (e.id == id) {
                    nm = e.cityName;
                }
            });
            return nm;
        },
        getLeaveDictAll() {
            crmApi.$ajaxworkerLeaveGetAllType().then((res) => {
                if (res.data.errno == 0) {
                    this.leaveTypeAll = res.data.data;
                }
            });
        },
        chuli(){
          if(this.addFrom.state==''){
            this.$message.error("请选择处理状态");
            return;
          }
          let params={
            id:this.tempRow.id,
            state: this.addFrom.state,
            comment: this.addFrom.comment
          }
          crmApi.$ajaxOperApplyTeam(params).then(res=>{
            if (res.data.errno == 0) {
              this.$message.success("操作成功");
              this.showcl = false;
              this.querySearch();
            }else {
              this.$message.error(res.data.errmsg);
            }
          }).catch(res=>{
            this.$message.error(res.data.errmsg);
          })
        }
    },
    beforeCreate() {
        vm = this;
    },
};
</script>
<style scoped>
.crumbs {
    margin: 0 0 10px 0;
}

.btn-margin .el-button--small {
    margin: 10px 12px 0 0;
}

.el-image img {
    height: 60px;
    width: 60px;
    margin: 0 12px 12px 0;
    object-fit: cover;
}
</style>
